import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { asPercent } from '../../../helpers';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { useTheme } from '@emotion/react';
import { IconButton, TableContainer, Button, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import {
  CardActions,
  CardContent,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination
} from '@mui/material';
import useClasses from '../../../helpers/useClasses';


import { DataGrid } from '@mui/x-data-grid';

const columns = [
  { field: 'fein', headerName: 'EIN', width: 500 },
];

const styles = theme => ({
  root: {},
  content: {
    padding: 0
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  processed_status_processed: {
    color: '#43a047',
    marginLeft: '20px'
  },
});

const MerchantScrubberUploadsTable = props => {
  const { 
    merchant_scrubber_uploads,
    plan_level,
    onAddMerchantScrubberClick,
    onMerchantScrubberReloadClick
  } = props;
  
  const classes = useClasses(styles);

  useEffect(() => {
  }, [merchant_scrubber_uploads])

  const renderFileSize = (file_size) => {
    let unit = 'bytes'

    if (Math.floor(file_size / 1073741824) > 0){
      file_size = Math.round(((file_size / 1073741824) + Number.EPSILON) * 100) / 100
      unit = 'GB'
      return `${file_size} ${unit}`
    }

    if (Math.floor(file_size / 1048576) > 0){
      file_size = Math.round(((file_size / 1048576) + Number.EPSILON) * 100) / 100
      unit = 'MB'
      return `${file_size} ${unit}`
    }

    if (Math.floor(file_size / 1024) > 0){
      file_size = Math.round(((file_size / 1024) + Number.EPSILON) * 100) / 100
      unit = 'KB'
    }
    
    return `${file_size} ${unit}`
  }

  return (
    <React.Fragment>
      <CardContent sx={{padding: 0}}>
        <PerfectScrollbar>
          <TableContainer className={classes.inner}>
          <Table>
               <TableHead sx={{
                backgroundColor: "#fafafa"
              }}>
                <TableRow>
                    <TableCell align={'left'} colspan={1}>
                        <Button
                            variant="text"
                            className={classes.button}
                            onClick={() => onMerchantScrubberReloadClick()}
                        >
                            Reload Results Table
                        </Button>
                    </TableCell>
                    <TableCell align={'right'} colspan={10}>
                        {/* { plan_level === 'PRO' ?
                        <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        startIcon={<AddIcon />}
                        onClick={() => onAddMerchantScrubberClick()}
                        >
                        Scrub Merchant List
                        </Button>
                        : 
                        <Link to="/pro"
                        // className={classes.noUnderline}
                        sx={{
                            textDecoration: 'none'
                        }}
                        >
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            className={classes.button}
                            
                        >
                            Scrub Merchant List
                        </Button>
                        </Link>
                        } */}
                        
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            className={classes.button}
                            onClick={() => onAddMerchantScrubberClick()}
                        >
                            Scrub Merchant List
                        </Button>
                    </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Uploaded</TableCell>
                  <TableCell>File Name</TableCell>
                  <TableCell>Size</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Processed</TableCell>
                  <TableCell colSpan={6}>Results</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {merchant_scrubber_uploads && merchant_scrubber_uploads.map(merchant_scrubber_upload => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={merchant_scrubber_upload.id}
                  >
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">
                          {moment(merchant_scrubber_upload.created_at).format('MM/DD/YYYY')}
                        </Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">
                          {merchant_scrubber_upload.file_name}
                        </Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">
                          {renderFileSize(merchant_scrubber_upload.file_size)}
                        </Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">
                          {merchant_scrubber_upload.status}
                        </Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        {merchant_scrubber_upload.processed && 
                          <CheckCircleOutlineIcon className={classes.processed_status_processed} />
                        }
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        {merchant_scrubber_upload.processed && 
                          <span>Scrubbed: {merchant_scrubber_upload.scrubbed}</span>
                        }
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        {merchant_scrubber_upload.processed && 
                          <span>Skipped: {merchant_scrubber_upload.skipped}</span>
                        }
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        {merchant_scrubber_upload.processed && 
                          <span>Found: {merchant_scrubber_upload.found}</span>
                        }
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        {merchant_scrubber_upload.processed && 
                          <span>Not Found: {merchant_scrubber_upload.not_found}</span>
                        }
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        {merchant_scrubber_upload.processed && 
                          <span>Errors: {merchant_scrubber_upload.error}</span>
                        }
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        {merchant_scrubber_upload.results_file_url && merchant_scrubber_upload.results_file_url.length > 0 &&
                          <Button
                            color="primary"
                            component="a"
                            href={"https://datamerch-imports.s3.amazonaws.com/"+ merchant_scrubber_upload.results_file_url}
                            variant="contained"
                          >
                            Download Results
                          </Button>
                        }
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </PerfectScrollbar>
      </CardContent>
    </React.Fragment>
  );
};

export default MerchantScrubberUploadsTable;
